

function extend(a, b, context) {
  forEach(b, function (val, key) {
    if (context && typeof val === 'function') {
      a[key] = bind(val, context);
    } else {
      a[key] = val;
    }
  });
  return a;
}

function bind(fn, context) {
  return function () {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(context, args);
  }
}

function isEmpty(value) {
  if (value === null || typeof value === "undefined") {
    return true;
  }
  if (Array.isArray(value)) {
    return !value.length;
  }
  if (typeof value === 'number') {
    value = value.toString();
  }
  if (typeof value === 'string') {
    return !String(value).trim().length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

var arrayEach = function (array, fn) {
  var index = -1,
    length = array == null ? 0 : array.length;

  while (++index < length) {
    if (fn(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var objectEach = function (object, fn) {
  for (var key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      if (fn(object[key], key, object) === false) {
        break;
      }
    }
  }
  return object;
}

function forEach(collection, fn) {
  var exeFn = Array.isArray(collection) ? arrayEach : objectEach;
  return exeFn(collection, fn);
}

function mapConvertObject(mapObj) {
  var obj = new Object();
  for (var [key, value] of mapObj) {
    obj[key] = value;
  }
  return obj;
}

//guid
function newGuid() {
  var guid = "";
  for (var i = 1; i <= 32; i++) {
    var n = Math.floor(Math.random() * 16.0).toString(16);
    guid += n;
    if ((i == 8) || (i == 12) || (i == 16) || (i == 20))
      guid += "";
  }
  return guid;
}
//随机数
let randomChars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
function getrandom(n) {
  var res = "";
  for (var i = 0; i < n; i++) {
    var id = Math.ceil(Math.random() * 61);
    res += randomChars[id];
  }
  return res;
}

function setCookie(key, value, options) {
  options = Object.assign({ path: '/' }, options);
  if (typeof options.expires === "number") {
    var days = options.expires, t = options.expires = new Date();
    t.setMilliseconds(t.getMilliseconds() + days * 864e+5);
  }
  var cookieValue = options.json ? JSON.stringify(value) : String(value);
  var arr = [
    cookieEncode(key), '=', cookieValue,
    options.expires ? '; expires=' + options.expires.toUTCString() : '',
    options.path ? '; Path=' + options.path : '',
    options.domain ? '; domain=' + options.domain : '',
    options.secure ? '; secure' : ''  //表示是否只能通过https传输
  ]
  document.cookie = arr.join('');
}

function getCookie(key, options) {
  options = Object.assign({}, options);
  var result = key ? "" : {};
  var cookies = document.cookie ? document.cookie.split('; ') : [];
  forEach(cookies, function (cok, i) {
    var strs = cok.split('=');
    var cokKey = cookieDecode(strs.shift());
    var value = options.json ? JSON.parse(strs[0]) : strs[0];
    if (key && cokKey == key) {
      result = value;
      return false;
    }
    if (!key) {
      result[cokKey] = options.json ? JSON.parse(value) : value;
    }
  });

  return result;
}

function cookieEncode(s) {
  return encodeURIComponent(s);
}
function cookieDecode(s) {
  return decodeURIComponent(s);
}

function convertMillionPrice(input) {
  var convertValue = input;
  if(typeof input != 'number'){
    convertValue = parseFloat(input);
  }
  if(isNaN(convertValue)){
    return input;
  }
  var temp = ((input / 10000).toFixed(4) + "").trimEnd("0").trimEnd("\\.");
  return parseFloat(temp);
}

function dateFormat(fmt, date) {
  if(typeof date==="string"){
    date = new Date(date);
  }
  let ret;
  let opt = {
      "Y+": date.getFullYear().toString(),        // 年
      "m+": (date.getMonth() + 1).toString(),     // 月
      "d+": date.getDate().toString(),            // 日
      "H+": date.getHours().toString(),           // 时
      "M+": date.getMinutes().toString(),         // 分
      "S+": date.getSeconds().toString()          // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
      };
  };
  return fmt;
}

export {
  extend, bind, forEach, isEmpty, mapConvertObject, newGuid, getrandom, setCookie, getCookie, convertMillionPrice,dateFormat
}


// WEBPACK FOOTER //
// ./src/util/util.js